import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LandingPage } from '../screens/home/LandingPage';
import { LoginScreen } from '../screens/auth/LoginScreen';
import { ForgotPasswordScreen } from '../screens/auth/ForgotPasswordScreen';

// Component to capture the intended destination and redirect to login with it
const LoginRedirect = () => {
  const location = useLocation();
  // Get the path the user was trying to access (excluding /login or /)
  const isPublicPath = location.pathname === '/' || location.pathname === '/login';
  const redirectTo = !isPublicPath ? location.pathname + location.search : undefined;
  
  // Store redirect URL in sessionStorage so it persists across navigator switches
  if (redirectTo) {
    sessionStorage.setItem('loginRedirect', redirectTo);
  }
  
  const redirectParam = redirectTo ? `?redirect=${encodeURIComponent(redirectTo)}` : '';
  return <Navigate to={`/login${redirectParam}`} replace />;
};

export const AuthNavigator = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
      <Route path="*" element={<LoginRedirect />} />
    </Routes>
  );
};
